/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Tracker_Type_Backinstock2Inputs */

const he_extension_tracker_type_backinstock2 = /** @type {(inputs: Extension_Tracker_Type_Backinstock2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חזרה למלאי`)
};

const en_extension_tracker_type_backinstock2 = /** @type {(inputs: Extension_Tracker_Type_Backinstock2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back in stock`)
};

/**
* | output |
* | --- |
* | "Back in stock" |
*
* @param {Extension_Tracker_Type_Backinstock2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_tracker_type_backinstock2 = /** @type {((inputs?: Extension_Tracker_Type_Backinstock2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Tracker_Type_Backinstock2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_tracker_type_backinstock2(inputs)
	return en_extension_tracker_type_backinstock2(inputs)
});
export { extension_tracker_type_backinstock2 as "extension_tracker_type_backInStock" }